import React from 'react';
import { useTheme } from '@emotion/react';
import { EditOutlined } from '@ant-design/icons';
import styled from 'types/theme.types';
import { ReactComponent as UnstyledEditIcon } from 'assets/images/editable-icon-green.svg';

// Component swap is new-design only: legacy keeps the 15x15 raw-svg pencil it always drew. The antd
// glyph at the shared 16px icon size, on the icon tokens - the raw svg sat on its own geometry and
// black fill beside every other icon (same treatment popup-entity's trash got).
const EditIcon: React.FC<React.SVGProps<SVGSVGElement> & { 'data-e2e'?: string }> = props => {
  const theme = useTheme();

  if (theme.isNewDesign) {
    // Spread, not a hand-picked four: most call sites wrap this in a Tooltip, and antd opens one by
    // cloning its child with onMouseEnter/onMouseLeave. Naming the props it forwards drops those, so
    // every edit tooltip on the new design stayed shut.
    return <StyledEditOutlined {...(props as React.ComponentProps<typeof StyledEditOutlined>)} />;
  }

  return <LegacyEditIcon {...props} />;
};

const StyledEditOutlined = styled(EditOutlined)`
  font-size: 16px;
  color: var(--icon-primary);
  transition: color 200ms ease-in;
  cursor: pointer;

  &:hover {
    color: var(--icon-primary-hover);
  }
`;

const LegacyEditIcon = styled(UnstyledEditIcon)`
  font-size: 19px;
  opacity: 1;
  transition: opacity 200ms ease-in;

  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }

  path,
  g {
    fill: ${({ theme }) => theme.primaryBlack};
  }
`;

export default EditIcon;
